import axios from 'axios';
import { v2ApiErrorHandler } from '@/api/lib/error-handler';
import * as Api from './index';

export const getStudentFilterStudentCount = async (filterParams) => {
    try {
        const queryString = Api.serializeObjectToQueryString(filterParams);
        const url = Api.getv2ApiBase(`/student-filters/student-count?${queryString}`);
        const options = Api.getOptions();

        const response = await axios.get(url, options);
        return response.data.count;
    } catch (error) {
        v2ApiErrorHandler({
            error
        });
    }
};

export const getStudentFilterStudentCountPost = async (filterParams) => {
    try {
        const url = Api.getv2ApiBase(`/student-filters/student-count`);
        const options = Api.getOptions();

        const response = await axios.post(url, filterParams, options);
        return response.data.count;
    } catch (error) {
        v2ApiErrorHandler({
            error
        });
    }
};

export const findStudentFilterById = async (studentFilterId) => {
    try {
        const url = Api.getv2ApiBase(`/student-filters/${studentFilterId}`);
        const options = Api.getOptions();

        const response = await axios.get(url, options);
        return response.data;
    } catch (error) {
        v2ApiErrorHandler({
            error
        });
    }
};

export const getStudentFilterStudentListByChatbotFlowId = async (chatbotFlowId) => {
    try {
        const url = Api.getv2ApiBase(`/student-filters/student-list/${chatbotFlowId}`);
        const options = Api.getOptions();

        const response = await axios.get(url, {
            ...options
        });
        return response.data;
    } catch (error) {
        v2ApiErrorHandler({
            error
        });
    }
};

export const listValidStudentIdsFromCsv = async (schoolId, file) => {
    try {
        const url = Api.getv2ApiBase(`/student-filters/student-list/list-student-ids-by-email`);
        const options = Api.getOptions();

        const formData = new FormData();
        formData.append('file', file);
        formData.append('schoolId', schoolId);

        const response = await axios.post(url, formData, options);
        return response.data;
    } catch (error) {
        v2ApiErrorHandler({
            error
        });
    }
};
